module.exports = __webpack_public_path__ + "img/download-mobile.6afd23da.svg";